import '../../css/style.scss'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {UIRulebookController} from '../../../shared/scripts/ui_rulebook/UIRulebookController'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared'
import {RulebookStyle} from '../../../../shared/enums/RulebookEnums'

void init()

async function init() {
    const fullscreen = window['rulebookStyle'] == RulebookStyle.Fullscreen
    if(fullscreen) {
        await EntryShared.initializeEntry()
    }

    new UIRulebookController()

    if(fullscreen) {
        EntrySingletonPageShared.initializeSocketAndGeneralServices(undefined)
    }
    EntryShared.sendPageVisitAnalyticEvent()
}
